<template>
  <div class="foot">
    <BottomBar v-if="this.$route.meta&&this.$route.meta=='home'"/>
    <div class="main">
      <span class="txt">  Copyright © 2018~{{currentYear}}&nbsp;{{$t('copyright')}}</span>
    </div>
  </div>
</template>

<script>
import BottomBar from "../components/BottomBar";
import dayjs from "dayjs"
export default {
  name: 'Foot',
  data() {
    return {
      currentYear: dayjs(new Date()).format("YYYY")
    };
  },
  components:{
    BottomBar
  },
  mounted(){

  },
}
</script>

<style scoped lang="less">
  .foot{
    text-align:center;
    padding:2px 0;
    background:#FFFFFF;
    .flogo{
      display: inline-block;
      transform:scale(.4,.4);
    }
    .txt{
      font-size:12px;
      position: relative;
      bottom: 3px;
    }
  }

</style>